var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-otp-input',_vm._g(_vm._b({ref:"otpContent",model:{value:(_vm.otpValue),callback:function ($$v) {_vm.otpValue=$$v},expression:"otpValue"}},'v-otp-input',{ ..._vm.$attrs, ..._vm.commonAttrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }